'use strict';

import { APIResponse } from "../APITypes";
import { csrfHeaders } from '../csrf';

export default class UserRegistrationEndpoint {
    static async Register(userRegistration: any): Promise<APIResponse<any>> {
        const response: Response = 
            await fetch(
                '/api/registration/register',
                {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        ...csrfHeaders()
                    },
                    body: JSON.stringify(userRegistration)
                }
            );
        
        if(!response.ok) {
            const errorData = await response.json().catch(() => ({}));
            throw new Error(errorData.error || "Registration failed.");
        }
        return await response.json();
    }

    static async SearchByEvent(searchOptions: any): Promise<APIResponse<any>> {
        const response: Response = 
            await fetch(
                '/api/registration/search',
                {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        ...csrfHeaders()
                    },
                    body: JSON.stringify(searchOptions)
                }
            );
        
        if(!response.ok) {
            throw new Error("User registration search failed.");
        }
        return await response.json();
    }

    static async Remove(user_registration_id: any): Promise<APIResponse<any>> {
        const response: Response = 
            await fetch(
                '/api/registration/remove',
                {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        ...csrfHeaders()
                    },
                    body: JSON.stringify({user_registration_id: user_registration_id})
                }
            );

        if(!response.ok) {
            throw new Error("Remove user registration failed.");
        }
        return await response.json();
    }

    static async Update(userRegistration: any): Promise<APIResponse<any>> {
        const response: Response = 
            await fetch(
                '/api/registration/update',
                {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        ...csrfHeaders()
                    },
                    body: JSON.stringify(userRegistration)
                }
            );
        
        if(!response.ok) {
            throw new Error("Update user registration failed.");
        }
        return await response.json();
    }

    static async UnregisterByEmail(emailHash: any, courseEventId: number): Promise<APIResponse<any>> {
        const response: Response = 
            await fetch(
                '/api/registration/unregister',
                {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        ...csrfHeaders()
                    },
                    body: JSON.stringify({
                        email_hash: emailHash,
                        course_event_id: courseEventId
                    })
                }
            );
        
        if(!response.ok) {
            const errorData = await response.json().catch(() => ({}));
            throw new Error(errorData.error || "Unregister failed.");
        }
        return await response.json();
    }
}